import { FILTER_TYPE } from 'components/FiltersBlock/types';

export const PROJECT_FILTER = {
  label: 'Проект',
  name: 'project',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/projects/?page=1',
};

export const PROJECT_MKD_FILTER = {
  label: 'Проект',
  name: 'project',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/projects/?checking_type=MKD&page=1',
};

export const PROJECT_IZS_FILTER = {
  label: 'Проект',
  name: 'project',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/projects/?checking_type=IZS&page=1',
};

export const PLACEMENT_FILTER = (isDistributed?: boolean) => {
  const params = new URLSearchParams({
    page: '1',
    ...(isDistributed !== undefined && { is_distributed: String(isDistributed) }),
  });

  return {
    label: 'Квартира',
    name: 'placement',
    type: FILTER_TYPE.SELECT,
    apiUrl: `/api/standards/placements/select_placements/?${params.toString()}`,
  };
};

export const CONTRACTOR_FILTER = {
  label: 'Подрядчик',
  name: 'contractor',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/contractors/?page=1',
};

export const CONSTRUCTION_STAGE_FILTER = (
  project: number | undefined,
  queue: number | undefined,
) => {
  const url = () => {
    if (!project && !queue) {
      return '/api/standards/construction-stages/';
    } else if (project && !queue) {
      return `/api/standards/construction-stages/?project=${project}`;
    } else if (!project && queue) {
      return `/api/standards/construction-stages/?queue=${queue}`;
    } else {
      return `/api/standards/construction-stages/?project=${project}&queue=${queue}`;
    }
  };
  return {
    label: 'Этап',
    name: 'stage',
    type: FILTER_TYPE.SELECT,
    apiUrl: url(),
  };
};

export const PERIOD_FILTER = {
  label: 'Период',
  name: 'period',
  type: FILTER_TYPE.RANGE_DATE_PICKER,
  rangeDateName: ['start', 'end'] as [string, string],
};

/* TODO дубль же? нельзя использовать DATE_FILTER?  */
export const REPORT_DATE_FILTER = {
  label: 'Дата отчёта',
  name: 'report_date',
  type: FILTER_TYPE.DATE_PICKER,
};

export const DATE_FILTER = {
  label: 'Дата',
  name: 'date',
  type: FILTER_TYPE.DATE_PICKER,
};

export const SECTION_FILTER = (structure: number | undefined) => {
  return {
    label: 'Секция',
    name: 'section',
    type: FILTER_TYPE.SELECT,
    showSearch: true,
    apiUrl: structure ? `/api/standards/structures/${structure}/sections/?page=1` : '',
  };
};

export const EMPLOYEE_FILTER = {
  label: 'Сотрудник',
  name: 'employee',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/employees/get_all_active_scs/?page=1',
};

export const APPLICANT_FILTER = {
  label: 'Заявитель',
  name: 'applicants',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/applicants/?page=1',
};

export const EMPLOYEES_FILTER = {
  label: 'Сотрудники',
  name: 'employees',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/employees/?page=1',
};

export const QUEUE_FILTER = {
  label: 'Очередь',
  name: 'queue',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/queues/?page=1',
};

export const QUEUE_IZS_FILTER = (project: number | null) => {
  return {
    label: 'Очередь',
    name: 'queue',
    type: FILTER_TYPE.SELECT,
    apiUrl: `/api/standards/izs-queues/?page=1&project=${project}`,
  };
};

export const QUEUE_PLAN_FILTER = {
  label: 'Очередь',
  name: 'actual_queue',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/actual-queues/?page=1',
};

export const IZS_PLACEMENTS_FILTER = (project: number | null, queue: number | undefined) => {
  return {
    label: 'Дом',
    name: 'placement',
    type: FILTER_TYPE.SELECT,
    apiUrl:
      project && queue
        ? `/api/standards/izs/queue/${queue}/select-placements/?page=1&project=${project}`
        : '',
  };
};

export const IZS_STAGES = (project: number | null, queue: number | undefined) => {
  return {
    label: 'Этап',
    name: 'stages',
    type: FILTER_TYPE.SELECT,
    apiUrl:
      project && queue
        ? `/api/standards/izs/queue/${queue}/select-stages/?page=1&project=${project}`
        : '',
  };
};

export const IZS_SUBTYPES_FILTER = {
  label: 'Тип проверки',
  name: 'subtypes',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/izs/select_subtypes/ ',
};

export const AUTHOR_FILTER = {
  label: 'Автор вызова',
  name: 'author',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/employees/prime_contractors/?page=1',
};

export const REVIEWER_FILTER = {
  label: 'Проверяющий',
  name: 'reviewer',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/employees/get_all_active_itu/?page=1',
};

export const BUSINESS_UNITS_FILTER = {
  label: 'Бизнес-юнит',
  name: 'business_unit',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/business-units/?page=1',
};

export const CLUSTERS_FILTER = {
  label: 'Кластер',
  name: 'cluster',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/clusters/?page=1',
};

export const STATE_THE_ROOM_FILTER = {
  label: 'Состояние помещения',
  name: 'statuscode',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/crm/real_estate_statuscodes/',
};

export const FINISHING_FILTER = {
  label: 'Наличие отделки',
  name: 'finishing',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/crm/finishing_codes/',
};
